import { formatCurrency, formatDate, getNextThirdTuesday } from "../../Utils/helpers";
import { nilYearLongMonthDateFormat } from "../../Utils/constants";

const nextThirdTuesday = getNextThirdTuesday();

export default function MyReturnOnRent({ rentMatch }) {
  return (
    <div className="my-return-on-rent">
      <p className="item-name">My Return on Rent</p>
      <h5 className="item-value">Earn {formatCurrency(rentMatch)}</h5>
      <p className="item-description">
        Get Cash Back for paying rent on time. Your next Rent Match is on{" "}
        {formatDate(nextThirdTuesday, nilYearLongMonthDateFormat)}.
      </p>
    </div>
  );
}
